<template>
    <el-container>
        <el-main style="padding: 20px 0 20px 0;">
            <div>
                <div class="item">
                    <div class="head">用户信息</div>
                    <div class="main flex-between">
                        <div class="main-item">
                            <span class="label">昵称：</span>
                            <span class="contain"></span>
                        </div>
                        <div class="main-item">
                            <span class="label">发布时间：</span>
                            <span class="contain">{{detail.created_at}}</span>
                        </div>
                        <div class="main-item">
                            <span class="label">状态：</span>
                            <span class="contain">{{detail.statusname}}</span>
                        </div>
                        <div class="main-item">
                            <span class="label">点赞人数：</span>
                            <span class="contain">{{detail.like_count}}</span>
                        </div>
                        <div class="main-item">
                            <span class="label">评论条数：</span>
                            <span class="contain">{{detail.comment_count}}</span>
                        </div>
                        <div class="main-item"></div>
                    </div>
                </div>
            
                <div class="item">
                    <div class="head">发布信息</div>
                    <div class="main">
                        <div class="main-item-m">
                            <span class="label">图片/视频：</span>
                            <span class="contain">
                                <block v-for="item in detail.content_list" :key="item.id">
                                    <img :src="viewContent(item.content)" v-if="item.content_type == 1">
                                    <video controls="controls" :src="viewContent(item.content)" v-else></video>
                                </block>
                            </span>
                        </div>
                        <div class="main-item-m">
                            <span class="label">发布文字：</span>
                            <span class="contain">{{detail.content}}</span>
                        </div>
                        <div class="main-item-m">
                            <span class="label">关联话题：</span>
                            <span class="contain">
                                <span class="view">{{detail.topic_list | getTopicName}}</span>
                            </span>
                        </div>
                    </div>
                </div> 
            
                <div class="item">
                    <div class="head">关联商品</div>
                    <div class="main">
                        <el-table :data="detail.product_list" class="tb-table">
                            <el-table-column prop="product_name" label="商品名称"/>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="view" @click="viewProductItem(scope.row.product_id)">查看详情</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>    
            
                <div class="item">
                    <div class="head">举报信息</div>
                    <div class="main flex-between">
                        <div class="main-item">
                            <span class="label">举报人昵称：</span>
                            <span class="contain">{{reportDetail.nick_name}}</span>
                        </div>
                        <div class="main-item">
                            <span class="label">举报时间：</span>
                            <span class="contain">{{reportDetail.created_at}}</span>
                        </div>
                        <div class="main-item">
                            <span class="label">举报类型：</span>
                            <span class="contain">{{reportDetail.reportTypeDesc}}</span>
                        </div>
                        <div style="width: 100%;display: block;">
                            <div style="margin-top: 16px;">
                                <span class="label">举报理由：</span>
                                <span class="contain">{{reportDetail.content}}</span>
                            </div>
                            <div style="margin-top: 16px;">
                                <span class="label">处理状态：</span>
                                <span class="contain" :class="reportDetail.statusStyleName">{{reportDetail.statusName}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <el-dialog title="关联话题" :visible.sync="dialogVisible" width="60%">
                    <div class="dialog-h">
                        <div class="item">
                            <span class="label"></span>
                            <span class="contain">
                                <el-input v-model="topicName"></el-input>
                            </span>
                        </div>
                        <el-button type="primary" @click="queryTopic">查询</el-button>
                    </div>
                    <div class="dialog-c">
                        <div v-if="topicList && topicList.length !== 0">
                            <el-table :data="topicList" class="tb-table">
                                <el-table-column label="话题标题">
                                    <template slot-scope="scope">
                                        <el-radio v-model="topicId" :label="scope.row.id"> {{scope.row.title}}</el-radio>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="subtitle" label="话题简介"/>
                            </el-table>
                        </div>
                        <div class="no-info" v-else>
                            <i class="el-icon-ice-tea"></i>
                            <span>暂无数据</span>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancelDialog">取 消</el-button>
                        <el-button type="primary" @click="submitEdit">确认修改</el-button>
                        <el-button type="primary" @click="cancelTopic">取消关联</el-button>
                    </div>
                </el-dialog>
            </div>
        </el-main>
        <el-footer style="padding:0">
            <div style="display: flex; justify-content: flex-end; align-items: center;height: 56px;background:rgba(255,255,255,1);
box-shadow:0px -1px 2px 0px rgba(0,0,0,0.03);padding-right: 24px;">
                        <el-button class="tb-button" @click="onCancel">取消</el-button>
                        <el-button class="tb-button" @click="rejectRow" v-if="reportDetail.status == 0">拒绝</el-button>
                        <el-button class="tb-button" type="primary" @click="passRow" v-if="reportDetail.status == 0">通过</el-button>
            </div>  
        </el-footer>
    </el-container>
        

</template>
<script>
export default {
    name:"FeedReportEdit",
    data(){
        return {
            detail:{},
            dialogVisible:false,
            topicList:[],
            topicName:"",
            topicId:"",
            reportDetail: {}
        }
    },
    mounted() {
        this.id = this.$route.query.id * 1 || null
        if (this.id) {
            this.getDetail()
        }
    },
    methods:{
        async getDetail() {
            const url = `admin/feed/report/detail?id=${this.id}`
            let data = await this.$https.get(url)
            if (!data) return
            this.reportDetail = data
            let reportType = [
                    {value:-1, name:'全部'},
                    {value:1, name:'广告、垃圾营销或售卖假货等'},
                    {value:2, name:'抄袭或盗用他人内容'},
                    {value:3, name:'违法、色情或涉政内容'},
                    {value:4, name:'造谣或欺诈'},
                    {value:5, name:'辱骂谩骂或不友善'},
                    {value:6, name:'其他'}
                ]
            this.reportDetail.reportTypeDesc = reportType[this.reportDetail.reportType]
            let statusname = ['待处理', '通过', '拒绝']
            this.reportDetail.statusName = statusname[this.reportDetail.status]
            statusname = ['blue', 'green', 'red']
            this.reportDetail.statusStyleName = statusname[this.reportDetail.status] 
            statusname = ['无效', '有效']
            data.statusname = statusname[data.feed_info.status]
            this.detail = data.feed_info
            this.topicId = data.feed_info.topic_id
        },
        viewContent(str){
            const strObj = JSON.parse(str);
            return strObj.url;
        },
        viewProductItem(id){
            this.$router.push(`/product/publish?id=${id}`)
        },
        viewTopic(){
            this.queryTopic();
            this.dialogVisible=true;
        },
        async queryTopic(){
            const url = `admin/feed/topic/list`
            const params = {
                page_no:0,
                page_size:20,
                title:this.topicName
            }
            const data = await this.$https.get(url, {params})
            this.topicList = data.list
        },
        passRow() {
            this.editStatus(this.reportDetail.id, 1)
        },
        rejectRow() {
           this.editStatus(this.reportDetail.id, 2)
        },
        editStatus(id, status) {
            const url = 'admin/feed/report/deal'
            const params = {id: id, status: status}
            this.$https.post(url, params).then(res => {
                if (res) this.getList()
            })
        },
        onCancel(){
            this.$router.push(`/feedReport/list`)
        },
        submitEdit(){
            const url = `admin/feed//modify/topic`
            let params = {
                id:this.id,
                topic_id: this.topicId
            }
            this.$https.post(url, params).then(data => {
                if (data) {
                    this.$message.success('修改成功');
                    this.cancelDialog();
                }
            })
        },
        cancelTopic(){
            const url = `admin/feed//modify/topic`
            let params = {
                id:this.id,
                topic_id: 0
            }
            this.$https.post(url, params).then(data => {
                if(data){
                    this.$message.success('取消成功');
                    this.cancelDialog();
                }
            })
        },
        cancelDialog(){
            this.dialogVisible=false;
        }
    },
    filters: {
        getTopicName(topicList) {
            let list = []
            if (topicList) {
                topicList.forEach(topic => {
                    list.push(topic.title)
                })
            }
            return list.join(',')
        }
    }
}
</script>
<style scoped lang="scss">
    .fix-head {
        padding-bottom: 24px;

        .title {
            padding-left: 16px;
        }

        .overview {
            text-align: right;

            &-item {
                flex-direction: column;

                .overview-label {
                    color: rgba(0, 0, 0, 0.45);
                    padding-bottom: 4px;
                }

                .overview-content {
                    font-size: 20px;
                    color: rgba(0, 0, 0, 0.65);
                }
            }

            .overview-item + .overview-item {
                margin-left: 40px;
            }
        }
    }

    .item {
        margin: 24px 24px 0;
        background-color: #fff;

        .head {
            padding: 16px 32px;
            font-size: 16px;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
            border-bottom: 1px solid #E9E9E9;
            box-sizing: border-box;
        }

        .main {
            padding: 24px 32px;
            flex-wrap: wrap;
            &-item {
                width: 33%;
                margin-top: 16px;
                min-height: 20px;
                .label {
                    min-width: 70px;
                    color: rgba(0, 0, 0, 0.85);
                }
                .contain {
                    min-width: 300px;
                    color: rgba(0, 0, 0, 0.65);
                }
            }
            .main-item:nth-child(-n+3) {
                margin-top: 0;
            }
            &-item-m{
                width: 100%;
                margin-top: 16px;
                .label {
                    min-width: 70px;
                    color: rgba(0, 0, 0, 0.85);
                    float: left;
                }
                .contain {
                    min-width: 300px;
                    color: rgba(0, 0, 0, 0.65);
                    img{
                        width: 200px;
                        height: 200px;
                        margin: 12px;
                    }
                    video{
                        width: 200px;
                        height: 200px;
                        margin: 12px;
                    }
                }
            }
            .view{
                color: #1890FF;
            }
        }
    }
    .dialog-h{
        width: 100%;
        overflow: hidden;
        position: relative;
        flex-wrap: wrap;
        padding: 10px 0;
        .item{
            width: 50%;
            float: left;
            margin: 0 16px 0 0;
            .label{
                width: 70px;
            }
            .contain {
                min-width: 300px;
            }
        }
    }
    .dialog-c{
        width: 100%;
            .no-info {
                text-align: center;
                font-size: 16px;
                color: rgba(0, 0, 0, 0.25);
            }
    }
    .blue {
        color: #1890FF;
    }
    .green {
        color: #1890FF;
    }
    .red {
        color: #F2637B;
    }
</style>